import StandardLink from "./StandardLink";
export default StandardLink;
